var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1EBBD7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.9,142.1l-46.1,46.1c-4.7,4.7-12.3,4.7-17,0l-111-111c-4.7-4.7-4.7-12.3,0-17l46.1-46.1 c18.7-18.7,49.1-18.7,67.9,0l60.1,60.1C516.7,92.9,516.7,123.3,497.9,142.1z M284.2,99.8L21.6,362.4L0.4,483.9 c-2.9,16.4,11.4,30.6,27.8,27.8l121.5-21.3l262.6-262.6c4.7-4.7,4.7-12.3,0-17l-111-111C296.5,95.1,288.9,95.1,284.2,99.8 L284.2,99.8z M124.1,339.9c-5.5-5.5-5.5-14.3,0-19.8l154-154c5.5-5.5,14.3-5.5,19.8,0s5.5,14.3,0,19.8l-154,154 C138.4,345.4,129.6,345.4,124.1,339.9L124.1,339.9z M88,424h48v36.3l-64.5,11.3l-31.1-31.1L51.7,376H88V424z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2c7274c8d1fcded0223954180d4b5169.svg";
export { ForwardRef as ReactComponent };